import { useMemo } from "react";
import { Column, useTable } from "react-table";
import { IconButton, TextField } from "@funcional/react-ui";
import {
  IDiscountRule,
  IDiscountRuleRange,
} from "@pbm/discount-rules/contracts";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import { UseFormRegister } from "react-hook-form";
import { ReactTable } from "@funcional/react-table-ui";

interface DiscountRuleRangeListProps {
  register: UseFormRegister<IDiscountRule>;
  addOption: Function;
  deleteOption: Function;
  data: IDiscountRuleRange[];
  errors: any;
}

interface RangeWithErrors extends IDiscountRuleRange {
  errors?: any;
}

export const DiscountRuleRangesForm = ({
  register,
  addOption,
  deleteOption,
  data,
  errors,
}: DiscountRuleRangeListProps) => {
  const preparedData = data.map((range, index) => ({
    ...range,
    errors: errors?.ranges?.[index],
  }));
  const columns: Column<RangeWithErrors>[] = useMemo(
    () =>
      [
        {
          Header: "De",
          accessor: "boxesFrom",
          Cell: ({
            row: {
              index,
              original: { errors },
            },
            value,
          }: any) => (
            <TextField
              type="number"
              defaultValue={value}
              errorMessage={errors?.boxesFrom?.message}
              {...register(`ranges.${index}.boxesFrom` as "ranges.0.boxesFrom")}
              size="small"
              inputProps={{ style: { minWidth: "1em" } }}
              placeholder="unidades"
            />
          ),
        },
        {
          Header: "Até",
          accessor: "boxesTo",
          Cell: ({
            row: {
              index,
              original: { errors },
            },
            value,
          }: any) => (
            <TextField
              type="number"
              defaultValue={value}
              errorMessage={errors?.boxesTo?.message}
              {...register(`ranges.${index}.boxesTo` as "ranges.0.boxesTo")}
              size="small"
              inputProps={{ style: { minWidth: "1em" } }}
              placeholder="unidades"
            />
          ),
        },
        {
          Header: "Desconto",
          accessor: "saleDiscountPercentage",
          Cell: ({
            row: {
              index,
              original: { errors },
            },
            value,
          }: any) => (
            <TextField
              type="number"
              defaultValue={value}
              errorMessage={errors?.saleDiscountPercentage?.message}
              {...register(
                `ranges.${index}.saleDiscountPercentage` as "ranges.0.saleDiscountPercentage"
              )}
              size="small"
              inputProps={{ style: { minWidth: "2em" } }}
              placeholder="%"
            />
          ),
        },
        {
          Header: "Cobertura",
          accessor: "daysBetweenSalesInterval",
          Cell: ({
            row: {
              index,
              original: { errors },
            },
            value,
          }: any) => (
            <TextField
              type="number"
              defaultValue={value}
              errorMessage={errors?.daysBetweenSalesInterval?.message}
              {...register(
                `ranges.${index}.daysBetweenSalesInterval` as "ranges.0.daysBetweenSalesInterval"
              )}
              size="small"
              inputProps={{ style: { minWidth: "2em" } }}
              placeholder="dias"
            />
          ),
        },
        {
          Header: "Tolerância",
          accessor: "daysWithoutSalesTolerance",
          Cell: ({
            row: {
              index,
              original: { errors },
            },
            value,
          }: any) => (
            <TextField
              type="number"
              defaultValue={value}
              errorMessage={errors?.daysWithoutSalesTolerance?.message}
              {...register(
                `ranges.${index}.daysWithoutSalesTolerance` as "ranges.0.daysWithoutSalesTolerance"
              )}
              size="small"
              inputProps={{ style: { minWidth: "2em" } }}
              placeholder="dias"
            />
          ),
        },
      ] as Column<RangeWithErrors>[],
    [register]
  );

  const tableInstance = useTable(
    { columns, data: preparedData },
    (hooks: any) => {
      hooks.visibleColumns.push((columns: any) => [
        ...columns,
        {
          id: "crud",
          Header: () => (
            <IconButton
              size="small"
              title="Adicionar faixa"
              onClick={addOption}
            >
              <AddIcon />
            </IconButton>
          ),
          Footer: () => (
            <IconButton
              size="small"
              title="Adicionar faixa"
              onClick={addOption}
            >
              <AddIcon />
            </IconButton>
          ),
          Cell: ({ row }: any) => (
            <div className="flex">
              <IconButton
                size="small"
                title="Excluir"
                onClick={() => deleteOption(row)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          ),
        },
      ]);
    }
  );

  return <ReactTable compact footer tableInstance={tableInstance} />;
};
